<template>
	<div>
		<el-breadcrumb separator-icon="ArrowRight" style="margin: 16px">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item>车型管理</el-breadcrumb-item>
			<el-breadcrumb-item>车型列表</el-breadcrumb-item>
		</el-breadcrumb>
		<el-card style="margin: 15px; min-height: calc(100vh - 111px)">
			<div>
				<!--    功能区-->
				<div style="margin: 10px 0">
					<!--    搜索区-->
					<div style="margin: 10px 0">
						<el-input v-model="search" clearable placeholder="请输入车型名称" prefix-icon="Search"
							style="width: 20%" />
						<el-button icon="Search" style="margin-left: 5px" type="primary" @click="load"></el-button>
						<el-button icon="refresh-left" style="margin-left: 10px" type="default"
							@click="reset"></el-button>
						<div style="float: right">
							<el-tooltip content="添加" placement="top">
								<el-button icon="plus" style="width: 50px" type="primary" @click="add"></el-button>
							</el-tooltip>
						</div>
					</div>
				</div>
				<!--    表格-->
				<el-table v-loading="loading" :data="tableData" border max-height="705" show-overflow-tooltip
					style="width: 100%">
					<el-table-column label="ID" prop="id" width="100px" />
					<el-table-column label="车型名称" prop="tradeName" />
					<el-table-column label="价格(天)" prop="points" />
					<el-table-column label="有效日期" width="300">
						<template #default="scope">
							<el-tag v-if="formatDateRange(scope.row.obtainingTime)" type="info" size="small">
								{{ formatDateRange(scope.row.obtainingTime) }}
							</el-tag>
							<span v-else>未设置日期</span>
						</template>
					</el-table-column>
					<!--      操作栏-->
					<el-table-column label="操作" width="130px">
						<template #default="scope">
							<el-button icon="Edit" type="primary" @click="handleEdit(scope.row)"></el-button>
							<el-button icon="Delete" type="danger" @click="handleDelete(scope.row.id)"></el-button>
						</template>
					</el-table-column>
				</el-table>
				<!--分页-->
				<div style="margin: 10px 0">
					<el-pagination v-model:currentPage="currentPage" :page-size="pageSize" :page-sizes="[10, 20]"
						:total="total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
						@current-change="handleCurrentChange">
					</el-pagination>
				</div>
				<!--      弹窗-->
				<div>
					<el-dialog v-model="dialogVisible" title="操作" width="30%" @close="cancel">
						<el-form ref="form" :model="form" :rules="rules" label-width="120px">
							<el-form-item label="车型名称" prop="tradeName">
								<el-input v-model="form.tradeName" style="width: 80%"></el-input>
							</el-form-item>
							<el-form-item label="价格(天)" prop="points">
								<el-input v-model="form.points" style="width: 80%"></el-input>
							</el-form-item>
							<el-form-item label="日期范围" prop="dateRange" style="margin-bottom: 27px">
								<el-date-picker
									v-model="form.dateRange"
									type="daterange"
									unlink-panels
									range-separator="至"
									start-placeholder="开始日期"
									end-placeholder="结束日期"
									format="YYYY-MM-DD"
									value-format="YYYY-MM-DD"
									:shortcuts="dateShortcuts"
									style="width: 80%"
								/>
							</el-form-item>
						</el-form>

						<template #footer>
							<span class="dialog-footer">
								<el-button @click="cancel">取 消</el-button>
								<el-button type="primary" @click="save">确 定</el-button>
							</span>
						</template>
					</el-dialog>
				</div>
			</div>
		</el-card>
	</div>
</template>
<script>
	import request from "@/utils/request";

	const {
		ElMessage,
		ElMessageBox
	} = require("element-plus");

	export default {
		name: "BuildingInfo",
		components: {},
		data() {
			return {
				loading: true,
				disabled: false,
				judge: false,
				status: 0,
				dialogVisible: false,
				search: "",
				currentPage: 1,
				pageSize: 10,
				total: 0,
				filename: "",
				imgurl: "",
				tableData: [],
				nameData: [],
				fileSelected: false,
				
				// 日期快捷选项
				dateShortcuts: [
					{
						text: '今天',
						value: () => {
							const today = new Date();
							return [today, today];
						}
					},
					{
						text: '本周',
						value: () => {
							const today = new Date();
							// 本周的开始日期（周日为第一天）
							const startOfWeek = new Date(today);
							startOfWeek.setDate(today.getDate() - today.getDay());
							// 本周的结束日期
							const endOfWeek = new Date(today);
							endOfWeek.setDate(today.getDate() + (6 - today.getDay()));
							return [startOfWeek, endOfWeek];
						}
					},
					{
						text: '本月',
						value: () => {
							const today = new Date();
							// 本月的第一天
							const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
							// 本月的最后一天
							const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
							return [startOfMonth, endOfMonth];
						}
					},
					{
						text: '未来一周',
						value: () => {
							const today = new Date();
							const start = new Date(today);
							const end = new Date(today);
							end.setDate(today.getDate() + 7);
							return [start, end];
						}
					},
					{
						text: '未来一月',
						value: () => {
							const today = new Date();
							const start = new Date(today);
							const end = new Date(today);
							end.setMonth(today.getMonth() + 1);
							return [start, end];
						}
					},
					{
						text: '未来三月',
						value: () => {
							const today = new Date();
							const start = new Date(today);
							const end = new Date(today);
							end.setMonth(today.getMonth() + 3);
							return [start, end];
						}
					}
				],
				
				form: {
					tradeName: "",
					points: "",
					dateRange: [], // 新增：日期范围数组
				},
				rules: {
					tradeName: [{
						required: true,
						message: "请输入车型名称",
						trigger: "blur"
					}],
					points: [{
						required: true,
						message: "请输入价格",
						trigger: "blur"
					}],
					dateRange: [{
						required: true,
						message: "请选择日期范围",
						trigger: "change"
					}],
				},

			};
		},
		created() {
			this.load();
			this.loading = true;
			setTimeout(() => {
				//设置延迟执行
				this.loading = false;
			}, 1000);
		},
		methods: {
			// 格式化日期范围显示
			formatDateRange(dateRangeStr) {
				if (!dateRangeStr) return '';
				try {
					const dateArray = dateRangeStr.split(',');
					if (dateArray.length === 2) {
						return `${dateArray[0]} 至 ${dateArray[1]}`;
					} else if (dateArray.length === 1) {
						return dateArray[0];
					}
					return dateRangeStr;
				} catch (error) {
					console.error("格式化日期范围出错:", error);
					return dateRangeStr;
				}
			},
			
			async load() {
				request.get("/goods/find", {
					params: {
						pageNum: this.currentPage,
						pageSize: this.pageSize,
						search: this.search,
					},
				}).then((res) => {
					this.tableData = res.data.records;
					this.avatar = res.data.records.picture;
					this.total = res.data.total;
					this.loading = false;
				});
				request.get("/publicize/find", {
					params: {
						pageNum: this.currentPage,
						pageSize: this.pageSize,
						search: this.search,
					},
				}).then((res) => {
					console.log(res.data.records);
					this.nameData = res.data.records;
				});
			},
			reset() {
				this.search = ''
				request.get("/goods/find", {
					params: {
						pageNum: 1,
						pageSize: this.pageSize,
						search: this.search,
					},
				}).then((res) => {
					console.log(res);
					this.tableData = res.data.records;
					this.total = res.data.total;
					this.loading = false;
				});
			},
			filterTag(value, row) {
				return row.dormBuildDetail === value;
			},
			add() {
				this.status = 1;
				this.dialogVisible = true;
				this.$nextTick(() => {
					this.$refs.form.resetFields();
					this.disabled = false;
					this.form = {
						tradeName: "",
						points: "",
						dateRange: [], // 重置为空的日期范围
					};
					this.judge = false;
				});
			},
			
			save() {
				this.$refs.form.validate((valid) => {
					if (valid) {
						// 复制表单数据，避免直接修改原始数据
						const requestData = {
							...this.form
						};
						
						// 处理日期范围：将数组转换为逗号分隔的字符串
						if (Array.isArray(requestData.dateRange) && requestData.dateRange.length === 2) {
							// 将日期范围数组转换为逗号分隔的字符串格式
							requestData.obtainingTime = requestData.dateRange.join(',');
						} else {
							// 如果没有选择日期范围，清空原来的字段
							requestData.obtainingTime = '';
						}
						
						// 删除临时的dateRange字段，避免后端接收错误
						delete requestData.dateRange;

						if (this.judge === false) {
							//新增
							request.post("/goods/add", requestData).then((res) => {
								console.log(res);
								if (res.code === "0") {
									ElMessage({
										message: "新增成功",
										type: "success",
									});
									this.search = "";
									this.load();
									this.dialogVisible = false;
								} else {
									ElMessage({
										message: res.msg,
										type: "error",
									});
								}
							});
						} else {
							//修改
							request.put("/goods/update", requestData).then((res) => {
								console.log(res);
								if (res.code === "0") {
									ElMessage({
										message: "修改成功",
										type: "success",
									});
									this.search = "";
									this.load();
									this.dialogVisible = false;
								} else {
									ElMessage({
										message: res.msg,
										type: "error",
									});
								}
							});
						}
					}
				});
			},
			cancel() {
				this.$refs.form.resetFields();
				this.dialogVisible = false;
			},
			handleEdit(row) {
				//修改
				this.status = 2;
				this.judge = true;
				this.dialogVisible = true;
				this.$nextTick(() => {
					this.$refs.form.resetFields();
					// 深拷贝
					const rowData = JSON.parse(JSON.stringify(row));
					
					// 处理日期范围：将后端返回的字符串转换为数组
					if (rowData.obtainingTime && typeof rowData.obtainingTime === 'string') {
						const dateArray = rowData.obtainingTime.split(',');
						if (dateArray.length === 2) {
							rowData.dateRange = [dateArray[0], dateArray[1]];
						} else if (dateArray.length === 1 && dateArray[0]) {
							// 如果只有一个日期，设置为相同开始和结束日期
							rowData.dateRange = [dateArray[0], dateArray[0]];
						} else {
							rowData.dateRange = [];
						}
					} else {
						rowData.dateRange = [];
					}
					
					// 保留原始obtainingTime字段，避免表单验证失败
					rowData.obtainingTime = row.obtainingTime;

					this.form = rowData;
					this.disabled = true;
				});
			},
			handleDelete(id) {
				ElMessageBox.confirm('确定要删除该商品吗？', '删除确认', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning',
					customClass: 'delete-dialog' // 可选：自定义对话框样式
				}).then(() => {
					// 用户点击确认后执行删除
					request.delete("/goods/delete/" + id).then((res) => {
						if (res.code === "0") {
							ElMessage({
								message: "删除成功",
								type: "success",
							});
							this.search = "";
							this.load(); // 刷新数据
						} else {
							ElMessage.error(res.msg || "删除失败");
						}
					}).catch((err) => {
						ElMessage.error("请求异常: " + err.message);
					});
				}).catch(() => {
					// 用户点击取消时的逻辑（可空）
					ElMessage.info("已取消删除");
				});
			},
			handleSizeChange(pageSize) {
				//改变每页个数
				this.pageSize = pageSize;
				this.load();
			},
			handleCurrentChange(pageNum) {
				//改变页码
				this.currentPage = pageNum;
				this.load();
			},
		},
	};
</script>
<style scoped>
	/* 可以添加一些自定义样式 */
	.el-tag {
		font-family: 'Microsoft YaHei', 'PingFang SC', sans-serif;
	}
	
	.el-date-editor--daterange.el-input__wrapper {
		border-radius: 4px;
	}
	
	.el-date-editor--daterange.el-input__wrapper:hover {
		border-color: #409eff;
	}
	
	.el-date-editor--daterange.el-input__wrapper.is-focus {
		border-color: #409eff;
		box-shadow: 0 0 0 1px #409eff inset;
	}
</style>